import styled, { css } from "styled-components";

interface IShowHideElementProps {
	$show: boolean;
}
export const ShowHideElementGridPart = styled.div<IShowHideElementProps>`
	${(props) =>
		!props.$show &&
		css`
			display: none !important;
		`}
`;
